module.exports = __webpack_public_path__ + "static/media/rules-puzzle-complete-dark.cf048949.png";